<template>
  <div :class="['flex flex-col mx-auto w-full max-w-screen-2xl', layout]">
    <template v-for="(item, index) in content.value">
      <div
        v-if="item.text"
        :key="index"
        :class="['prose prose-lg max-w-full lg:max-w-screen-2xl', textStyle(item.text)]"
        v-html="htmlText(item.text.content)"
      ></div>
      <div v-if="item.br === null" :key="index" class="h-4" />
      <div v-if="item.hr === null" :key="index" class="w-full py-4">
        <hr />
      </div>
      <div v-if="item.image" :key="index" :class="imageLayout(item.image)">
        <img
          v-bind="disalbeCopy"
          :src="webpImage(item.image.path)"
          :class="['max-w-full my-4', imageStyle(item.image)]"
        />
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { IContext } from '@/store/modules/common/types';
import { Vue, Component, Prop } from 'vue-property-decorator';
import showdown from 'showdown';
import { webpImage } from '@forchange/cleword-utils';

@Component
export default class StorySlide extends Vue {
  @Prop({ type: Object, default: () => {} }) content!: IContext & { value: Array<any> };

  get layout() {
    const values = this.content.value.filter((item) => {
      return !!item.layout;
    });
    if (!values[0]) return '';
    return this.markLayout(values[0].layout);
  }

  get disalbeCopy() {
    if (this.$store.state.common.disalbeCopy) {
      return {
        style:
          'user-select: none;-webkit-user-drag: none;-webkit-user-select: none;-webkit-touch-callout: none;',
        oncontextmenu: 'return false;'
      };
    }
    return {}
  }

  webpImage(url: string) {
    return webpImage(url);
  }

  textStyle(text: { weight: number; size: number; align: string }) {
    const classArr = [];
    const fontWeight = [
      '',
      'font-thin',
      'font-extralight',
      'font-light',
      'font-normal',
      'font-medium',
      'font-semibold',
      'font-bold'
    ];
    const fontSize = [
      '',
      'text-xs',
      'text-sm',
      'text-base',
      'text-lg',
      'text-xl',
      'text-2xl',
      'text-3xl'
    ];

    if (text.weight) {
      classArr.push(fontWeight[text.weight]);
    }

    if (text.size) {
      classArr.push(fontSize[text.size]);
    }

    switch (text.align) {
      case '居左':
      case 'left':
        classArr.push('self-start');
        break;
      case '居中':
      case 'center':
        classArr.push('self-center');
        break;
      case '居右':
      case 'right':
        classArr.push('self-end');
        break;
      default:
        classArr.push('self-center');
    }

    return classArr.join(' ');
  }

  imageLayout(image: { align: string }) {
    const classArr = [];
    switch (image.align) {
      case '居左':
      case 'left':
        classArr.push('self-start');
        break;
      case '居中':
      case 'center':
        classArr.push('self-center');
        break;
      case '居右':
      case 'right':
        classArr.push('self-end');
        break;
      default:
        classArr.push('self-center');
    }
    return classArr.join(' ');
  }

  imageStyle(image: { size: number }) {
    const fontSize = ['', 'w-16', 'w-32', 'w-64', 'w-96', 'w-128', 'w-160', 'w-200'];
    return fontSize[image.size] || '';
  }

  markLayout(layout: { xAxis: string; yAxis: string; width: string }) {
    const classArr = [];

    switch (layout.xAxis) {
      case '居左':
      case 'left':
        classArr.push('items-start');
        break;
      case '居中':
      case 'center':
        classArr.push('items-center');
        break;
      case '居右':
      case 'right':
        classArr.push('items-end');
        break;
      default:
        classArr.push('items-center');
    }

    switch (layout.yAxis) {
      case '顶部':
      case 'top':
        classArr.push('justify-start');
        break;
      case '居中':
      case 'center':
        classArr.push('justify-center');
        break;
      case '底部':
      case 'bottom':
        classArr.push('justify-end');
        break;
      default:
        classArr.push('justify-center');
    }

    // width
    switch (layout.width) {
      case '大':
      case 'large':
        classArr.push('lg:w-11/12');
        break;
      case '中':
      case 'middle':
        classArr.push('lg:w-8/12');
        break;
      case '小':
      case 'small':
        classArr.push('lg:w-6/12');
        break;
      default:
        classArr.push('lg:w-10/12');
    }

    return classArr.join(' ');
  }

  htmlText(value: string): string {
    const converter = new showdown.Converter({
      simpleLineBreaks: true,
      openLinksInNewWindow: true
    });
    return converter.makeHtml(value);
  }
}
</script>
<style scoped>
.image-max {
  max-height: 80vh;
}
</style>
